import React from 'react';
import AboutUs from './AboutUs';
import HowItWorks from './HowItWorks';
import ClinicalPractices from './ClinicalPractices';

const AboutUsContainer: React.FC = () => {
    return (
        <div id="about-us">
            <AboutUs />
            <HowItWorks />
            <ClinicalPractices />
        </div>
    );
};

export default React.memo(AboutUsContainer);
